<template>
  <v-autocomplete
    v-model="cityLocation"
    label="City"
    :items="computedCities"
    item-text="name"
    item-value="slug"
    class="my-2"
    return-object
    dense
    outlined
    clearable
    :disabled="hasSearchTerm"
    @change="changeLocation"
  />
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'BlogLocationFilter',
  computed: {
    ...mapState('user', ['profile']),
    ...mapState('route', ['query']),
    ...mapState('location', ['navigatorPosition']),
    cityLocation: {
      get() {
        return this.$store.state.location.cityLocation
      },
      set(city) {
        this.$store.commit('location/setCityLocation', city)
      },
    },
    computedCities() {
      const cities = this.$store.state.location.availableCities
      if (cities.length === 0) {
        this.$store.dispatch('location/CITIES/REQUEST')
      }

      return this.$store.state.location.availableCities.map((city) => {
        return {
          ...city,
          disabled:
            city.name.includes('COMING SOON') ||
            (city.name.includes('My current location') &&
              this.navigatorPosition === null),
        }
      })
    },
    hasSearchTerm() {
      return (
        typeof this.query.searchTerm !== 'undefined' &&
        this.query.searchTerm !== ''
      )
    },
  },
  watch: {
    cityLocation() {
      if (
        typeof this.cityLocation !== 'undefined' &&
        this.cityLocation !== null
      )
        this.changeLocation(this.cityLocation.id)
    },
    hasSearchTerm() {
      if (this.hasSearchTerm) {
        const { city: _, ...query } = this.query

        this.$router.push({
          name: 'blog',
          query,
        })

        this.cityLocation = null
      }
    },
  },
  mounted() {
    if (typeof this.cityLocation !== 'undefined' && this.cityLocation !== null)
      this.changeLocation(this.cityLocation.id)
  },
  methods: {
    changeLocation(city) {
      const query = {
        ...this.query,
        page: 1,
        city: (city && city.id) || city,
      }

      this.$router.push({ name: 'blog', query })
    },
  },
}
</script>
